export * from 'utils/vnode.js';

// Collect every <option> VNode at any depth, for components that accept them as children like a native <select>
export function findOptionTags(node) {
	if (Array.isArray(node)) {
		return node.flatMap(findOptionTags);
	}
	return node?.nodeName === 'option' ? [node] : findOptionTags(node?.children || []);
}

// Swap every <option> VNode for whatever the replacer returns, keeping the surrounding structure (e.g. <hr> separators) intact
export function replaceOptionTags(node, replacer) {
	if (Array.isArray(node)) {
		return node.map(child => child?.nodeName === 'option' ? replacer(child) : replaceOptionTags(child, replacer));
	}
	return !node?.children ? node : { ...node, children: replaceOptionTags(node.children, replacer) };
}
